import React from 'react';
import { Navigate } from 'react-router-dom';
import { Game as Whacka } from '../../games/whacka/game';
import { Game as MatchThree, GameMode } from '../../games/matchThree/game';
import { Game as Solitaire } from '../../games/solitaire/game';
import { Database } from '../../server/database';
import { Server } from '../../server/server';
import './PlayGamePage.css'

interface PlayGamePageState {
  gameOver: boolean;
}

class PlayGamePage extends React.Component<{}, PlayGamePageState> {
  protected game: any;

  constructor(props: {}) {
    super(props);
    this.game = null;
    this.onGameEvent = this.onGameEvent.bind(this);
    this.state = {
      gameOver: false
    }
  }

  getGameId():string {
    return window.location.pathname.substring(6);
  }

  componentDidMount() {
    let gameId = this.getGameId();

    let canvas = document.getElementById('GameCanvas') as HTMLCanvasElement;
    if(!canvas) return;

    let tournament = (window.location.search == '?contest');

    if (gameId == 'whacka') 
      this.game = new Whacka(canvas, this.onGameEvent, tournament);
    else if (gameId == 'solitaire') 
      this.game = new Solitaire(canvas, this.onGameEvent, tournament);
    else if (gameId == 'matcha-blitz') 
      this.game = new MatchThree(canvas, this.onGameEvent, GameMode.Arcade, tournament);
    else if (gameId == 'matcha-adventure') 
      this.game = new MatchThree(canvas, this.onGameEvent, GameMode.Adventure, tournament);

    this.game.load();
  }

  componentWillUnmount() {
    if(this.game) {
      this.game.unload();
      this.game = null;
    }
  }

  async onGameEvent(event:string) {
    let gameId = this.getGameId();
    Server.games.clearLeaderboardCache(gameId)
    this.setState({gameOver: true});
  }

  render() {
    if(!Server.account.isLoggedIn())
      return <Navigate to="/" replace />;

    let gameId = this.getGameId();
    let game = Database.getGame(gameId);
    let tournament = (window.location.search == '?contest');

    if(!game)
      return (<Navigate to="/play" />);
      
    if(this.state.gameOver)
      if(tournament) 
        return (<Navigate to={'/contest/' + gameId}/>)
      else 
        return (<Navigate to={'/game/' + gameId}/>)
    else
      return (
        <div className="canvas-container">
          <canvas id="GameCanvas" className="game-canvas"/>
        </div>
      );
  }
}

export default PlayGamePage;
